import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { PendingCount } from '../../types/Order';
import { logout } from './authSlice';

const initialState: PendingCount = { count: 0, latestCreatedAt: null };

const pendingOrdersSlice = createSlice({
    name: 'pendingOrders',
    initialState,
    reducers: {
        setPendingOrders: (_state, action: PayloadAction<PendingCount>) => action.payload,
        /** Optimistic change while an order write is in flight; the server count replaces it right after. */
        adjustPendingOrders: (state, action: PayloadAction<number>) => {
            state.count = Math.max(0, state.count + action.payload);
        },
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => initialState);
    },
});

export const { setPendingOrders, adjustPendingOrders } = pendingOrdersSlice.actions;
export default pendingOrdersSlice.reducer;
